import { useEffect, useState } from 'react'
import StaticMap, { Marker } from 'react-map-gl'
import { useParcelsSearch } from '~/api'
import { SimpleParcelsLayer } from '~/components/common'
import { Listing } from '~/models'
import { MAPBOX_ACCESS_TOKEN } from '~/utils'

const pinStyle = {
  // cursor: 'pointer',
  filter: 'drop-shadow(1px 1px 1px rgb(0 0 0 / 0.25))',
}

function Pin({ size = 20, type = '' }) {
  const strokeWidth = size / 6
  if (type === 'sale') {
    return (
      <svg
        className="pin"
        height={size - 2}
        width={size - 2}
        viewBox={`0 0 ${size - 2} ${size - 2}`}
        style={{ filter: 'drop-shadow(1px 1px 1px rgb(0 0 0 / 0.25))' }}>
        <polygon
          points="9,1 17,17 1,17"
          fill="#0284c7"
          stroke="#fff"
          strokeWidth={strokeWidth}
        />
      </svg>
    )
  } else if (type === 'saleLease') {
    return (
      <svg
        className="pin"
        height={size - 3}
        width={size - 3}
        viewBox={`0 0 ${size - 3} ${size - 3}`}
        style={{ filter: 'drop-shadow(1px 1px 1px rgb(0 0 0 / 0.25))' }}>
        <polygon
          points="2,2 16,2 16,16 2,16"
          fill="#4f46e5"
          stroke="#fff"
          strokeWidth={strokeWidth}
        />
      </svg>
    )
  }

  return (
    <svg
      className="pin ml-[-1px]"
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={pinStyle}>
      <circle
        stroke="#fff"
        strokeWidth={strokeWidth}
        fill="#c026d3"
        cx={size / 2}
        cy={size / 2}
        r={size / 2 - strokeWidth}></circle>
    </svg>
  )
}

export default function ListingStaticMap({ listing }: { listing: Listing }) {
  const [isLoaded, setIsLoaded] = useState(false)

  const { parcels } = useParcelsSearch({
    latitude: listing.property.latitude,
    longitude: listing.property.longitude,
  })

  useEffect(() => {
    setIsLoaded(true)
  }, [])

  if (!isLoaded) {
    return null
  }

  return (
    <StaticMap
      initialViewState={{
        longitude: listing.location.coordinates[0],
        latitude: listing.location.coordinates[1],
        zoom: 16,
      }}
      mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
      customAttribution="Associate™ by Resimplifi"
      mapStyle="mapbox://styles/mapbox/streets-v11"
      style={{ width: '100%', height: '100%' }}>
      <Marker
        longitude={listing.location?.coordinates[0]}
        latitude={listing.location?.coordinates[1]}
        anchor="bottom">
        <span className="pointer-events-none">
          <Pin type={listing.type} />
        </span>
      </Marker>
      {parcels.length > 0 && <SimpleParcelsLayer parcels={[parcels[0]]} />}
    </StaticMap>
  )
}
